<template>
  <div id="app">
    <Home></Home>
  </div>
</template>

<script>
import Home from "./views/Home";

export default {
  name: "App",
  components: { Home },
};
</script>

<style lang="scss" src="./scss/main.scss"></style>
